
import * as ProjectTypesActions from './actions';
import { createReducer, on, Action } from '@ngrx/store';
import { State, initializeProjectTypesState } from '@app/root-store/project-type-store/state';
import { entityAdapter } from '@app/root-store/adapter';
import { IProjectType } from '@app/models/project-type.model';


export const initialState = initializeProjectTypesState();

const reducer = createReducer(
  initialState,
  on(ProjectTypesActions.GetProjectTypesAction, state => ({...state, isLoading : true})),
  on(ProjectTypesActions.ProjectTypesLoadedAction, (state: State, { payload }) => {
    return {
      ...state,
      types: payload,
      isLoading : false
    };
  }),
  on(ProjectTypesActions.BeginCreateProjectTypeAction, state => ({...state, isLoading : true})),
  on(ProjectTypesActions.SuccessCreateProjectTypeAction, (state: State, { payload }) => {
    return {
      ...state,
      types: [...state.types, payload],
      isLoading : false
    };
  }),
  on(ProjectTypesActions.BeginUpdateProjectTypeAction, state => ({...state, isLoading : true})),
  on(ProjectTypesActions.SuccessUpdateProjectTypeAction, (state: State, { payload }) => {
    return {
      ...state,
      types: [...state.types.map(e => e._id !== payload._id ? e :  payload)],
      isLoading : false
    };
  }),
  on(ProjectTypesActions.BeginRemoveProjectTypeAction, state => ({...state, isLoading : true})),
  on(ProjectTypesActions.SuccessRemoveProjectTypeAction, (state: State, { payload }) => {
    return {
      ...state,
      types: [...state.types.filter(e => e._id !== payload._id)],
      isLoading : false
    };
  }),
  on(ProjectTypesActions.BeginFetchSelectedProjectTypeAction, state => ({...state, isSelectedTypeLoading: true})),
  on(ProjectTypesActions.SuccessFetchSelectedProjectTypeAction, (state: State, { payload }) => {
    return {
      ...state,
      selectedType: payload,
      isSelectedTypeLoading: false
    };
  }),
  on(ProjectTypesActions.BeginAddSectionAction, state => state),
  on(ProjectTypesActions.SuccessAddSectionAction, (state: State, { payload }) => {
    return {
      ...state,
      selectedType: payload
    };
  }),
  on(ProjectTypesActions.BeginMoveFieldToSectionAction, state => state),
  on(ProjectTypesActions.SuccessMoveFieldToSectionAction, (state: State, { payload }) => {
    return {
      ...state,
      selectedType: payload
    };
  }),
  on(ProjectTypesActions.BeginConnectFieldToProjectTypeAction, state => state),
  on(ProjectTypesActions.SuccessConnectFieldToProjectTypeAction, (state: State, { payload }) => {
    return {
      ...state,
      selectedType: payload.projectType
    };
  }),
  on(ProjectTypesActions.BeginChangeSectionNameAction, state => state),
  on(ProjectTypesActions.SuccessChangeSctionNameAction, (state: State, { payload }) => {
    return {
      ...state,
      selectedType: payload.projectType
    };
  }),
  on(ProjectTypesActions.BeginMoveSectionAction, state => state),
  on(ProjectTypesActions.SuccessMoveSectionAction, (state: State, { payload }) => {
    return {
      ...state,
      selectedType: payload.projectType
    };
  }),
);

export function ProjectTypeReducer(state: State | undefined, action: Action) {
  return reducer(state, action);
}
